<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="开始日期"
              v-model="form.beginTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
          <el-col
            class="line"
            :span="1"
          >-</el-col>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="结束日期"
              v-model="form.endTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <SelectInput
        v-model="searchValue"
        :dbclickFlag="false"
        :showGroup="false"
        style="margin: 20px"
      />
      <el-select v-model="form.type">
        <el-option label="全部" value=""></el-option>
        <el-option label="4G上传" :value="1"></el-option>
        <el-option label="蓝牙上传" :value="2"></el-option>
      </el-select>
      <el-button
        style="margin-left: 32px"
        size="small"
        type="primary"
        @click="getRealtimeAlarmReport()"
      >查询</el-button>

      <el-button
        style="margin-left: 10px"
        size="small"
        @click="exportNoxReport"
      >导出</el-button>
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="bmsNo"
          label="电池编号"
          width="120"
          align="center"
        />
        <el-table-column
          prop="terminalType"
          label="终端类型"
          width="130"
          align="center"
        />
        <el-table-column
          property="t"
          label="终端时间"
          width="150"
          align="center"
        />
        <el-table-column
          property="devData"
          label="原始数据"
          align="center"
        >
          <template #default="{row}">
            {{row.devData || '暂无数据'}}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="详情"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="getAll(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getRealtimeAlarmReport"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
    <div slot="plugins">
      <dataShow
        :visible.sync="batteryVisible"
        :batteryData.sync="batteryData"
      />
    </div>
  </ManageBox>
</template>

<script>
import day from "dayjs";
import ManageBox from "@/components/ManageBox/index.vue";
import SelectInput from "@/components/SelectInput/index.vue";
import dataShow from "./dataShow.vue";
import { mapState } from 'vuex';

export default {
  components: {
    ManageBox,
    SelectInput,
    dataShow
  },
  data() {
    return {
      selectMonitorInfo:null,
      batteryVisible: false,
      batteryData: {},
      batteryType: "",
      terminalType: "",
      loading: false,
      dialogData: null,
      detailDialog: false,
      form: {
        type:'',
        beginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59:0"),
        dayBeginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        )
      },
      searchValue: null,
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0
    };
  },
  computed:{
      ...mapState(['USER']),
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
    // this.getRealtimeAlarmReport();
  },

  methods: {
    //导出功能
    exportNoxReport(){
      let params = {
        mostParentId:this.$store.state.USER.mostParentId,
        vehicleId:this.searchValue.vehicleId,
        type:this.form.type,
        beginTime:day(this.form.beginTime || this.form.dayBeginTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        pageSize:this.pageSize,
        pageNumber:this.currentPage
      }
      console.log(params);
      this.$API.writeBmsSourceExcel(params);
    },
    //获取电池所有信息
    async getAll(data) {
        this.batteryData = data;
        console.log(data);
        this.batteryVisible = true;
    },
    currentChange (val) {
      this.currentPage = val;
      console.log(val)
      this.getRealtimeAlarmReport();
    },
    //获取电池历史数据
    async getRealtimeAlarmReport() {
      let params = {
        beginTime: day(this.form.beginTime || this.form.dayBeginTime).format(
          "YYYY-MM-DD HH:mm:ss:0"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss:999"
        ),
        pageSize:this.pageSize,
        pageNumber:this.currentPage,
        type:this.form.type
      };
      if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("vehicleId")
      ) {
        params.vehicleId = this.searchValue.vehicleId;
      }
      if (this.form.beginTime > this.form.endTime) {
        this.$msg({
          showClose: true,
          message: "开始时间不能大于结束时间!",
          type: "error"
        });
        return;
      }
      if (this.searchValue === null) {
        this.$msg({
          showClose: true,
          message: "请选择/输入终端ID",
          type: "error"
        });
        return;
      }
      this.getParams = params;
      try {
        this.loading = true;
        const { data, total } = await this.$API.getBmsTrack(params);
        this.total = total;
        const otherData = {
          bmsNo: data.bmsNo,
          bmsType: data.bmsType,
          groupId: data.groupId,
          groupName: data.groupName,
          terminalType: data.terminalType,
          vehicleId: data.vehicleId
        };

        this.tableData = data.bmsList.map((item, index) => ({
          ...otherData,
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        console.log(this.tableData)
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-pagination {
//   padding-top: 20px;
// }
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 420px;
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
</style>
